module.exports = __webpack_public_path__ + "img/intro-text-image.7d2ceb52.png";